export default "__VITE_ASSET__D5s8zGiW__"